<template>
    <div>
        <div class="pt-4">
            <div
                class="alert alert-warning"
                role="alert"
                v-if="details && (!details.isEnableEdit || isSubmitted)"
            >
                <span v-if="isSubmitted">
                    This form has been submitted by client, therefore can no
                    longer be edited.
                </span>
                <span v-else>
                    This form has been sent to client, therefore can no longer
                    be edited.
                </span>
            </div>

            <loader-profile
                v-if="!isSurveyJSLoaded"
                :is-full="true"
                class="p-2"
            ></loader-profile>

            <SurveyCreator
                class="border"
                :webform="details"
                :webformContent="webformContent"
                :isEnableEdit="details.isEnableEdit"
                :module="module"
                @setWebformContent="data => (webformContent = data)"
                @setSurveyDirty="isDirty => setWebformDirty(isDirty)"
                @loaded="isLoaded => (isSurveyJSLoaded = isLoaded)"
            />
        </div>
    </div>
</template>

<script>
import { isEmpty } from "lodash";

export default {
    components: {
        LoaderProfile: () => import("@/components/elements/loader-profile.vue"),
        SurveyCreator: () =>
            import("@/components/setting-webform/survey-creator.vue")
    },
    data() {
        return {
            isSurveyJSLoaded: false
        };
    },
    computed: {
        module() {
            if (this.$route.name == "patient_webform") {
                return "patient";
            }
            return "client";
        },
        details: {
            get() {
                return this.$store.state.webform.details;
            },
            set(value) {
                this.$store.commit("webform/setDetails", value);
            }
        },
        webformContent: {
            get() {
                return this.$store.state.webform.webformContent;
            },
            set(value) {
                this.$store.commit("webform/setWebformContent", value);
            }
        },
        isSubmitted() {
            return this.details && !isEmpty(this.details.submitted_at);
        }
    },
    beforeDestroy() {
        this.webformContent = null;
    },
    methods: {
        setWebformDirty(isDirty) {
            this.$store.commit("webform/setDirty", isDirty);
        }
    }
};
</script>
